var _defs, _g, _path, _path2, _path3, _polyline, _polygon, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceComparisonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 38 250 296.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#00f531;}.cls-4{fill:#00f431;}.cls-5{fill:#00f331;}.cls-6{fill:#00f230;}.cls-7{fill:#00f130;}.cls-8{fill:#00f030;}.cls-9{fill:#00ef30;}.cls-10{fill:#00ee30;}.cls-11{fill:#00ed2f;}.cls-12{fill:#00ec2f;}.cls-13{fill:#00eb2f;}.cls-14{fill:#00ea2f;}.cls-15{fill:#00e92e;}.cls-16{fill:#00e82e;}.cls-17{fill:#00e72e;}.cls-18{fill:#00e62e;}.cls-19{fill:#00e52e;}.cls-20{fill:#00e42e;}.cls-21{fill:#00e32d;}.cls-22{fill:#00e22d;}.cls-23{fill:#00e12d;}.cls-24{fill:#00e02d;}.cls-25{fill:#00df2c;}.cls-26{fill:#00de2c;}.cls-27{fill:#00dd2c;}.cls-28{fill:#00dc2c;}.cls-29{fill:#00db2c;}.cls-30{fill:#00da2b;}.cls-31{fill:#00d92b;}.cls-32{fill:#00d82b;}.cls-33{fill:#00d62b;}.cls-34{fill:#00d52b;}.cls-35{fill:#00d42a;}.cls-36{fill:#00d32a;}.cls-37{fill:#00d22a;}.cls-38{fill:#00d12a;}.cls-39{fill:#00d02a;}.cls-40{fill:#00cf29;}.cls-41{fill:#00ce29;}.cls-42{fill:#00cd29;}.cls-43{fill:#00cc29;}.cls-44{fill:#00cb28;}.cls-45{fill:#00ca28;}.cls-46{fill:#03f;}.cls-47{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.41,
    y: 65.25,
    width: 49.95,
    height: 65.72,
    rx: 2.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "76.36 66.18 73.36 65.25 76.36 65.25 76.36 66.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "76.36 68.08 67.32 65.25 73.36 65.25 76.36 66.18 76.36 68.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "76.36 69.97 61.28 65.25 67.32 65.25 76.36 68.08 76.36 69.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "76.36 71.86 55.24 65.25 61.28 65.25 76.36 69.97 76.36 71.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "76.36 73.75 49.2 65.25 55.24 65.25 76.36 71.86 76.36 73.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "76.36 75.64 43.16 65.25 49.2 65.25 76.36 73.75 76.36 75.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "76.36 77.53 37.12 65.25 43.16 65.25 76.36 75.64 76.36 77.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "76.36 79.42 31.07 65.25 37.12 65.25 76.36 77.53 76.36 79.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "76.36 81.32 26.41 65.68 26.41 65.25 31.07 65.25 76.36 79.42 76.36 81.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "76.36 83.21 26.41 67.57 26.41 65.68 76.36 81.32 76.36 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "76.36 85.1 26.41 69.46 26.41 67.57 76.36 83.21 76.36 85.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "76.36 86.99 26.41 71.35 26.41 69.46 76.36 85.1 76.36 86.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "76.36 88.88 26.41 73.25 26.41 71.35 76.36 86.99 76.36 88.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "76.36 90.77 26.41 75.14 26.41 73.25 76.36 88.88 76.36 90.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "76.36 92.67 26.41 77.03 26.41 75.14 76.36 90.77 76.36 92.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "76.36 94.56 26.41 78.92 26.41 77.03 76.36 92.67 76.36 94.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "76.36 96.45 26.41 80.81 26.41 78.92 76.36 94.56 76.36 96.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "76.36 98.34 26.41 82.7 26.41 80.81 76.36 96.45 76.36 98.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "76.36 100.23 26.41 84.59 26.41 82.7 76.36 98.34 76.36 100.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "76.36 102.12 26.41 86.48 26.41 84.59 76.36 100.23 76.36 102.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "76.36 104.01 26.41 88.38 26.41 86.48 76.36 102.12 76.36 104.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "76.36 105.91 26.41 90.27 26.41 88.38 76.36 104.01 76.36 105.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "76.36 107.8 26.41 92.16 26.41 90.27 76.36 105.91 76.36 107.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "76.36 109.69 26.41 94.05 26.41 92.16 76.36 107.8 76.36 109.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "76.36 111.58 26.41 95.94 26.41 94.05 76.36 109.69 76.36 111.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "76.36 113.47 26.41 97.83 26.41 95.94 76.36 111.58 76.36 113.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "76.36 115.36 26.41 99.72 26.41 97.83 76.36 113.47 76.36 115.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "76.36 117.25 26.41 101.62 26.41 99.72 76.36 115.36 76.36 117.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "76.36 119.15 26.41 103.51 26.41 101.62 76.36 117.25 76.36 119.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "76.36 121.04 26.41 105.4 26.41 103.51 76.36 119.15 76.36 121.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "76.36 122.93 26.41 107.29 26.41 105.4 76.36 121.04 76.36 122.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "76.36 124.82 26.41 109.18 26.41 107.29 76.36 122.93 76.36 124.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "76.36 126.71 26.41 111.07 26.41 109.18 76.36 124.82 76.36 126.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "76.36 128.6 26.41 112.97 26.41 111.07 76.36 126.71 76.36 128.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "76.36 130.5 26.41 114.86 26.41 112.97 76.36 128.6 76.36 130.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "71.81 130.97 26.41 116.75 26.41 114.86 76.36 130.5 76.36 130.97 71.81 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "65.77 130.97 26.41 118.64 26.41 116.75 71.81 130.97 65.77 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "59.73 130.97 26.41 120.53 26.41 118.64 65.77 130.97 59.73 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "53.69 130.97 26.41 122.42 26.41 120.53 59.73 130.97 53.69 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "47.65 130.97 26.41 124.31 26.41 122.42 53.69 130.97 47.65 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "41.61 130.97 26.41 126.21 26.41 124.31 47.65 130.97 41.61 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "35.56 130.97 26.41 128.1 26.41 126.21 41.61 130.97 35.56 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "29.52 130.97 26.41 129.99 26.41 128.1 35.56 130.97 29.52 130.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "26.41 129.99 29.52 130.97 26.41 130.97 26.41 129.99"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M73.33,131.53H29.43a3.59,3.59,0,0,1-3.59-3.59V68.27a3.59,3.59,0,0,1,3.59-3.59h43.9a3.59,3.59,0,0,1,3.59,3.59v59.67A3.59,3.59,0,0,1,73.33,131.53ZM29.43,65.82A2.46,2.46,0,0,0,27,68.27v59.67a2.47,2.47,0,0,0,2.46,2.46h43.9a2.46,2.46,0,0,0,2.46-2.46V68.27a2.46,2.46,0,0,0-2.46-2.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M25.19,108.41a.15.15,0,0,1,0-.07l.18-6.85a.19.19,0,0,1,.09-.15l7.28-3.61a.16.16,0,0,1,.21,0l1.75,2.31,14.89-9.82a.15.15,0,0,1,.18,0,.13.13,0,0,1,.06.07.14.14,0,0,1,0,.11l-.38,1.71,3.93-.74a.17.17,0,0,1,.18.09l.86,1.7,5.76-4.62a.15.15,0,0,1,.17,0L65.57,91l2.6-3.23a.17.17,0,0,1,.18-.05l8.52,3a.19.19,0,0,1,.1.1,0,0,0,0,0,0,0l.6,3.47a.17.17,0,0,1-.06.16.15.15,0,0,1-.17,0l-8-3.55L66.63,95a.18.18,0,0,1-.2.07L61,93.34l-7,6.09a.17.17,0,0,1-.18,0L49,97.08,38.6,104.55a.15.15,0,0,1-.13,0,.12.12,0,0,1-.1-.07l-1.47-2.24-5.35,3a.17.17,0,0,1-.22,0l-.76-1-5.12,4.19a.17.17,0,0,1-.18,0A.24.24,0,0,1,25.19,108.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M76.81,90.82l.6,3.47-8.14-3.61-2.78,4.26-5.56-1.79L53.81,99.3,49,96.88,38.5,104.42,37,102.05l-5.48,3.09L30.6,104l-5.25,4.31.18-6.86,7.28-3.61,1.84,2.43,15-9.9-.44,2,4.18-.79,1,1.89,5.92-4.75,5.34,2.48,2.68-3.33,8.51,2.95m.31-.13a.35.35,0,0,0-.2-.18l-8.51-3a.34.34,0,0,0-.37.11l-2.51,3.12-5.11-2.36a.32.32,0,0,0-.35,0L54.47,93l-.76-1.52a.34.34,0,0,0-.36-.17L49.67,92,50,90.48a.35.35,0,0,0-.14-.35.35.35,0,0,0-.37,0L34.72,99.86l-1.65-2.19a.34.34,0,0,0-.41-.09l-7.28,3.61a.37.37,0,0,0-.19.29L25,108.34a.32.32,0,0,0,0,.14.37.37,0,0,0,.16.17.34.34,0,0,0,.36-.05l5-4.08.65.83a.35.35,0,0,0,.43.08l5.22-2.93,1.37,2.1a.34.34,0,0,0,.22.15.4.4,0,0,0,.26-.06L49,97.27l4.62,2.33a.34.34,0,0,0,.37,0l7-6,5.38,1.74a.34.34,0,0,0,.39-.14l2.62-4,7.89,3.5a.33.33,0,0,0,.34,0,.31.31,0,0,0,.12-.32l-.6-3.47a.19.19,0,0,0,0-.07Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "27.4 100.26 24.47 101 24.56 109 26.57 108.27"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "76.52 90.37 78.91 91.03 78.74 94.94 77.11 94.71 76.41 94.28 75.95 91.94 75.94 90.85 76.52 90.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M98.16,99.29a3.66,3.66,0,0,1,.76,2.3,3.76,3.76,0,0,1-1.32,3.08,5.77,5.77,0,0,1-3.78,1.09h-8V90.56H93.6a5.93,5.93,0,0,1,3.65,1,3.45,3.45,0,0,1,1.33,2.94,3.53,3.53,0,0,1-.7,2.24A3.29,3.29,0,0,1,96,98,3.59,3.59,0,0,1,98.16,99.29Zm-7.54-2.8h1.84a1.51,1.51,0,0,0,1-.26,1,1,0,0,0,.31-.8,1,1,0,0,0-.31-.82,1.45,1.45,0,0,0-1-.27H90.62Zm3.12,5.2a1,1,0,0,0,.31-.8c0-.73-.42-1.1-1.26-1.1H90.62v2.15h2.17A1.54,1.54,0,0,0,93.74,101.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M108.17,105.76l-2.85-5.45h0v5.45h-4.77V90.56h7.08a6.93,6.93,0,0,1,3.16.66,4.48,4.48,0,0,1,2,1.78,4.93,4.93,0,0,1,.66,2.54,4.52,4.52,0,0,1-.85,2.7,4.66,4.66,0,0,1-2.44,1.7l3.31,5.82Zm-2.87-8.63h1.89a1.49,1.49,0,0,0,1-.31,1.29,1.29,0,0,0,.34-1,1.24,1.24,0,0,0-.36-.94,1.38,1.38,0,0,0-1-.35H105.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M119.68,94.36v1.87h4.72v3.58h-4.72V102H125v3.8H114.91V90.56H125v3.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M136.59,103.46h-5.07l-.75,2.3h-5l5.56-15.2h5.49l5.54,15.2h-5Zm-1.16-3.58-1.38-4.23-1.37,4.23Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M152.61,105.76l-4.42-6.59v6.59h-4.76V90.56h4.76V97l4.36-6.4h5.39l-5.24,7.28,5.58,7.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M160.11,94.13a6.57,6.57,0,0,1,2.61-2.74,7.87,7.87,0,0,1,4-1,8.13,8.13,0,0,1,3.53.74,6.59,6.59,0,0,1,2.54,2.1,7.51,7.51,0,0,1,1.29,3.15h-5a2.74,2.74,0,0,0-1-1.17,2.59,2.59,0,0,0-1.45-.42,2.27,2.27,0,0,0-1.9.9,4.55,4.55,0,0,0,0,4.85,2.27,2.27,0,0,0,1.9.9,2.58,2.58,0,0,0,1.45-.41,2.74,2.74,0,0,0,1-1.17h5a7.51,7.51,0,0,1-1.29,3.15,6.57,6.57,0,0,1-2.54,2.09,8,8,0,0,1-3.53.74,7.86,7.86,0,0,1-4-1,6.63,6.63,0,0,1-2.61-2.74,9.29,9.29,0,0,1,0-8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M179.26,104.9a7.49,7.49,0,0,1-2.85-2.79,8.2,8.2,0,0,1,0-8,7.53,7.53,0,0,1,2.85-2.78,8.3,8.3,0,0,1,7.86,0,7.45,7.45,0,0,1,2.82,2.78,8.27,8.27,0,0,1,0,8,7.43,7.43,0,0,1-2.83,2.79,8.13,8.13,0,0,1-7.85,0Zm6.12-4.35a4.28,4.28,0,0,0,0-4.93,2.7,2.7,0,0,0-2.19-.92,2.75,2.75,0,0,0-2.21.92,4.33,4.33,0,0,0,0,4.93,2.75,2.75,0,0,0,2.21.91A2.69,2.69,0,0,0,185.38,100.55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M211,90.56v15.2h-4.74V98.18l-2.34,7.58H199.8l-2.34-7.58v7.58H192.7V90.56h5.84l3.35,9.12,3.26-9.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M224.87,98.38a4.79,4.79,0,0,1-2,1.86,6.59,6.59,0,0,1-3.14.69h-1.89v4.83h-4.76V90.56h6.65A6,6,0,0,1,224,92a5,5,0,0,1,1.49,3.8A5.16,5.16,0,0,1,224.87,98.38Zm-4.17-2.6c0-.93-.49-1.4-1.48-1.4h-1.35v2.79h1.35C220.21,97.17,220.7,96.71,220.7,95.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceComparisonLogo);
export default __webpack_public_path__ + "static/media/Price Comparison Logo.5331deee54be94ccc0672f80961ec65b.svg";
export { ForwardRef as ReactComponent };